package com.hyperether.goodjob.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class AssociatedObject(
    @SerialName("id") var id: String,
    @SerialName("type") var type: String
)